module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/ignite-session-16-may-2026.json
// module id = 1356
// module chunks = 246327643246349